"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExternalMappingCsvUploadBase = exports.useVoucherAttachmentUploadBase = exports.useVoucherUploadBase = exports.useFileUploadBase = exports.FileUploadStatus = void 0;
var react_1 = require("react");
var const_1 = require("remota-common/const");
var loading_1 = require("./loading");
var notification_1 = require("./notification");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
exports.FileUploadStatus = {
    WAITING: "wairing",
    URL_GENERATING: "preparing",
    UPLOADING: "uploading",
    UPLOADED: "uploaded",
    DONE: "done",
};
var toFileUploadStatus = function (urlStatus, uploadStatus, doneStatus) {
    if (doneStatus.isLoaded) {
        return exports.FileUploadStatus.DONE;
    }
    else if (uploadStatus.isLoaded) {
        return exports.FileUploadStatus.UPLOADED;
    }
    else if (uploadStatus.isLoading) {
        return exports.FileUploadStatus.UPLOADING;
    }
    else if (urlStatus.isLoaded) {
        return exports.FileUploadStatus.UPLOADING;
    }
    else if (urlStatus.isLoading) {
        return exports.FileUploadStatus.URL_GENERATING;
    }
    else {
        return exports.FileUploadStatus.WAITING;
    }
};
var useFileUploadBase = function (params, loadingState, requestUrl, finishUrl, onFinish, onFailure) {
    var _a, _b, _c, _d, _e, _f;
    var _g = __read((0, react_1.useState)({ file: undefined, info: undefined }), 2), state = _g[0], setState = _g[1];
    var setInfo = (0, react_1.useCallback)(function (info) {
        setState({ file: state.file, info: info });
    }, [state.file]);
    var handleFinish = (0, react_1.useCallback)(function () {
        onFinish(state);
    }, [onFinish, state]);
    var handleFailure = (0, react_1.useCallback)(function () {
        onFailure(state);
    }, [onFailure, state]);
    var uploadOption = (0, react_1.useMemo)(function () {
        var _a;
        return ({
            headers: (_a = {}, _a[const_1.TOKEN_HEADER_KEY] = undefined, _a),
            params: { t: undefined },
        });
    }, []);
    var uploadStatus = (0, loading_1.useHttpPut)(loadingState, (_b = (_a = state.info) === null || _a === void 0 ? void 0 : _a.uploadUrl) !== null && _b !== void 0 ? _b : "", state.file, ((_c = state.info) === null || _c === void 0 ? void 0 : _c.uploadUrl) !== undefined && state.file !== undefined, undefined, handleFailure, uploadOption);
    var urlStatus = (0, loading_1.useHttpPost)(loadingState, requestUrl, __assign(__assign({}, params), { fileName: (_d = state.file) === null || _d === void 0 ? void 0 : _d.name }), state.file !== undefined, setInfo, handleFailure);
    var doneRequest = (0, react_1.useMemo)(function () {
        var _a, _b;
        var fileId = (_a = state.info) === null || _a === void 0 ? void 0 : _a.fileId;
        if (!fileId || !uploadStatus.isLoaded) {
            return undefined;
        }
        var success = uploadStatus.error === null;
        return __assign(__assign({}, params), { fileId: fileId, fileName: (_b = state.file) === null || _b === void 0 ? void 0 : _b.name, success: success });
    }, [params, (_e = state.file) === null || _e === void 0 ? void 0 : _e.name, (_f = state.info) === null || _f === void 0 ? void 0 : _f.fileId, uploadStatus.error, uploadStatus.isLoaded]);
    var doneStatus = (0, loading_1.useHttpPost)(loadingState, finishUrl, doneRequest, doneRequest !== undefined, handleFinish, handleFailure);
    var upload = (0, react_1.useCallback)(function (file) {
        setState({ file: file, info: undefined });
    }, []);
    return (0, react_1.useMemo)(function () { return [upload, toFileUploadStatus(urlStatus, uploadStatus, doneStatus)]; }, [
        upload,
        uploadStatus,
        urlStatus,
        doneStatus,
    ]);
};
exports.useFileUploadBase = useFileUploadBase;
var useVoucherUploadBase = function (loadingState, jobInputId, jobId, isExternal) {
    var params = (0, react_1.useMemo)(function () { return ({ jobInputId: jobInputId, jobId: jobId }); }, [jobInputId, jobId]);
    var notify = (0, notification_1.useNotify)();
    var successMsg = (0, translate_1.fat)("{{name}}をアップロードしました。");
    var errorMsg = (0, translate_1.fat)("{{name}}のアップロードに失敗しました。S3バケットのCORS設定を確認してください。");
    var onUploadFinish = (0, react_1.useCallback)(function (state) {
        notify({
            message: isExternal
                ? (0, fat_1.deFat)((0, translate_1.fat)("{{FILE_NAME}}をアップロードしました。"), function (str) { var _a; return str.replace("{{FILE_NAME}}", ((_a = state.file) === null || _a === void 0 ? void 0 : _a.name) || ""); })
                : (0, fat_1.deFat)(successMsg, function (msg) { var _a; return msg.replace("{{name}}", ((_a = state.file) === null || _a === void 0 ? void 0 : _a.name) || ""); }),
            severity: "success",
        });
    }, [notify, successMsg, isExternal]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        // TODO: エラー内容を出し分けしたい
        notify({
            message: isExternal
                ? (0, fat_1.deFat)((0, translate_1.fat)("{{FILE_NAME}}をアップロードに失敗しました。"), function (str) { var _a; return str.replace("{{FILE_NAME}}", ((_a = state.file) === null || _a === void 0 ? void 0 : _a.name) || ""); })
                : (0, fat_1.deFat)(errorMsg, function (str) { var _a; return str.replace("{{name}}", ((_a = state.file) === null || _a === void 0 ? void 0 : _a.name) || ""); }),
            severity: "error",
        });
    }, [notify, errorMsg, isExternal]);
    return (0, exports.useFileUploadBase)(params, loadingState, "/api/".concat(isExternal ? "external/" : "", "file/url/voucher"), "/api/".concat(isExternal ? "external/" : "", "file/url/done"), onUploadFinish, onUploadFailure);
};
exports.useVoucherUploadBase = useVoucherUploadBase;
var useVoucherAttachmentUploadBase = function (loadingState, voucherId) {
    var params = (0, react_1.useMemo)(function () { return ({ voucherId: voucherId }); }, [voucherId]);
    var notify = (0, notification_1.useNotify)();
    var onUploadSuccess = (0, react_1.useCallback)(function (state) {
        notify({
            message: (0, fat_1.deFat)((0, translate_1.fat)("添付ファイルをアップロードしました。")),
            severity: "success",
        });
    }, [notify]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        // TODO: エラー内容を出し分けしたい
        notify({
            message: (0, fat_1.deFat)((0, translate_1.fat)("添付ファイルのアップロードに失敗しました。")),
            severity: "error",
        });
    }, [notify]);
    return (0, exports.useFileUploadBase)(params, loadingState, "/api/file/url/attachment", "/api/file/url/attachment/done", onUploadSuccess, onUploadFailure);
};
exports.useVoucherAttachmentUploadBase = useVoucherAttachmentUploadBase;
var useExternalMappingCsvUploadBase = function (loadingState, onFinish) {
    var notify = (0, notification_1.useNotify)();
    var onUploadFinish = (0, react_1.useCallback)(function (state) {
        onFinish(state);
    }, [onFinish]);
    var onUploadFailure = (0, react_1.useCallback)(function (state) {
        // TODO: エラー内容を出し分けしたい
        notify({
            message: (0, fat_1.deFat)((0, translate_1.fat)("CSVのアップロードに失敗しました。")),
            severity: "error",
        });
    }, [notify]);
    return (0, exports.useFileUploadBase)({}, loadingState, "/api/file/url/external-mapping", "/api/file/url/external-mapping/done", onUploadFinish, onUploadFailure);
};
exports.useExternalMappingCsvUploadBase = useExternalMappingCsvUploadBase;
